import React from 'react';
import { Button, Modal } from 'antd';
import {  FormattedMessage } from 'react-intl';
import styles from './EmailConfigurationModal.module.scss';
import EmailConfigurationModalContent from './EmailConfigurationModalContent';
import messages from '../../../Containers/ManualSearchV2/ManualSearchMessages';

function EmailConfigurationModal(props) {
  const {
    addNewEmailAddressFlag,
    currentEmailConfiguration = {},
    setCurrentEmailConfiguration,
    emailProviders,
    userEmails,
    orgDefaultEmail,
    isAdmin,
    emailConfigurationModalVisiblity,
    form,
    submitEmailConfiguration,
    setEmailConfigurationModalVisiblity,
    emailSmtpConfiguration,
    deleteEmailConfig,
    SetNotification,
  } = props;
  const isDefaultEmailConfiguration = currentEmailConfiguration.EmailId === orgDefaultEmail.EmailId;
  const handleSubmitEmailConfiguration = () => {
    form.validateFieldsAndScroll({ force: true }, err => {
      if (!err) {
        submitEmailConfiguration(addNewEmailAddressFlag, currentEmailConfiguration, isDefaultEmailConfiguration);
        setEmailConfigurationModalVisiblity(false);
      }
    });
  };
  const editPopupHeader =
    currentEmailConfiguration.EmailId === orgDefaultEmail.EmailId ? <FormattedMessage {...messages.editDefaultEmailLabel} /> : <FormattedMessage {...messages.editCustomEmailLabel} />;
  return (
    <Modal
        title={addNewEmailAddressFlag ? <FormattedMessage {...messages.addNewEmailLabel} /> : editPopupHeader}
        width={880}
        visible={emailConfigurationModalVisiblity}
        footer={[
          <Button
            key="cancel"
            shape="round"
            onClick={() => {
              setEmailConfigurationModalVisiblity(false);
            }}
          >
            <FormattedMessage {...messages.cancelLabel} />
          </Button>,
          <Button key="submit" type="primary" shape="round" onClick={handleSubmitEmailConfiguration}>
            <FormattedMessage {...messages.confirmLabel} />
          </Button>,
        ]}
        onCancel={() => {
          setEmailConfigurationModalVisiblity(false);
        }}
        className={styles.emailConfigurationModal}
        bodyStyle={{ padding: '0px 24px' }}
        maskClosable={false}
        destroyOnClose
      >
        <EmailConfigurationModalContent
          userEmails={userEmails}
          orgDefaultEmail={orgDefaultEmail}
          form={form}
          currentEmailConfiguration={currentEmailConfiguration}
          setCurrentEmailConfiguration={setCurrentEmailConfiguration}
          isAdmin={isAdmin}
          emailProviders={emailProviders}
          emailSmtpConfiguration={emailSmtpConfiguration}
          addNewEmailAddressFlag={addNewEmailAddressFlag}
          deleteEmailConfig={deleteEmailConfig}
          isDefaultEmailConfiguration={isDefaultEmailConfiguration}
          SetNotification={SetNotification}
        />
      </Modal>
  );
}

export default EmailConfigurationModal;
